import { render, staticRenderFns } from "./drag-dialog.vue?vue&type=template&id=5b921582"
import script from "./drag-dialog.vue?vue&type=script&lang=js"
export * from "./drag-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data0/web/xyadmin.98du.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b921582')) {
      api.createRecord('5b921582', component.options)
    } else {
      api.reload('5b921582', component.options)
    }
    module.hot.accept("./drag-dialog.vue?vue&type=template&id=5b921582", function () {
      api.rerender('5b921582', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components-demo/drag-dialog.vue"
export default component.exports